import React from 'react';
// We have deprecated emotion. Please use compiled instead
// eslint-disable-next-line no-restricted-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import { token } from '@atlaskit/tokens';

import SearchErrorImage from './images/SearchErrorImage.svg';

const i18n = defineMessages({
	errorHeader: {
		id: 'home.views.error.header',
		// TODO: replace straight quotes with curly quotes (see go/curlyquotes)
		// eslint-disable-next-line no-restricted-syntax
		defaultMessage: "We're having trouble getting your results",
		description:
			'Header that appears on a Home View when an error occurs during initial load or searching/filtering.',
	},
	errorAction: {
		id: 'home.views.error.action',
		defaultMessage: 'Refresh the page and try again.',
		description:
			'Action text that appears on a Home View when an error occurs during initial load or searching/filtering.',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const ErrorContainer = styled.div`
	margin-top: 68px;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const ErrorHeader = styled.h3`
	margin-top: 37px;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const ErrorAction = styled.div`
	margin-top: ${token('space.200', '16px')};
`;

export const Error = () => (
	<ErrorContainer>
		<img src={SearchErrorImage} alt="" />
		<ErrorHeader>
			<FormattedMessage {...i18n.errorHeader} />
		</ErrorHeader>
		<ErrorAction>
			<FormattedMessage {...i18n.errorAction} />
		</ErrorAction>
	</ErrorContainer>
);
